export class ArticleCamFile {
  constructor(
    public hash: string,
    public mimeType: string,
    public fileName: string,
    public filePath: string,
    public isPDF: boolean,
    public isImage: boolean
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/article-cam-file.ts